var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.635,
    height: 32,
    viewBox: "0 0 42.635 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M42.635,13.538,40.5,14.77,38.371,16,36.24,14.768l-2.132-1.23-2.132,1.23V32l-2.133-1.232-2.13-1.23V17.23l-2.132,1.232-2.132,1.23-1.563.9-.569.328-.569-.328-1.563-.9-2.132-1.23L14.922,17.23V29.538l-2.13,1.23L10.659,32V14.768l-2.132-1.23L6.4,14.768,4.263,16,2.132,14.77,0,13.538l2.132-1.23.418-.242,1.714-.99L6.4,9.847,8.527,8.615l2.132,1.23V0l4.263,2.46v9.847l2.132,1.232,2.132,1.23L21.317,16l2.132-1.232,2.132-1.23,2.132-1.232V2.46L31.976,0V9.845l2.132-1.23L36.24,9.847l2.132,1.23,1.714.99.418.242Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1c531cab2fe8677abcedc1ce7b78e4b0.svg";
export { ForwardRef as ReactComponent };